/*
 * CMP-025 Numeric pagination — Phase A1. No dependencies. Draws "1 2 3 … 9" (Figma 66:15195) from a page and a page count.
 * Pure helper pageItems(current, total) is exported for node:test: the first and last page are always shown, the current page
 * with one neighbour on each side, the first three pages while the current one is 1 or 2 (and the last three at the end);
 * a gap of a single page is shown as that page instead of an ellipsis. setPage(page, pages) redraws; a page count of 1 or
 * less hides the control. Click on a page fires the bubbling `nc-pagination:change` {page}; the host decides what to load
 * and where focus goes. The current page is a button (aria-current="page") that emits nothing, so a stale focus is never lost.
 */
(function () {
  function pageItems(current, total) {
    total = Math.max(1, Math.floor(total) || 1);
    current = Math.min(total, Math.max(1, Math.floor(current) || 1));
    if (total <= 1) return [1];
    var set = {};
    [1, total, current - 1, current, current + 1].forEach(function (n) { set[n] = true; });
    if (current <= 2) [1, 2, 3].forEach(function (n) { set[n] = true; });
    if (current >= total - 1) [total - 2, total - 1, total].forEach(function (n) { set[n] = true; });
    var pages = Object.keys(set).map(Number).filter(function (n) { return n >= 1 && n <= total; }).sort(function (a, b) { return a - b; });
    var out = [];
    pages.forEach(function (n, i) {
      var prev = pages[i - 1];
      if (prev && n - prev === 2) out.push(prev + 1);
      else if (prev && n - prev > 2) out.push('…');
      out.push(n);
    });
    return out;
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { pageItems: pageItems };
  if (typeof customElements === 'undefined' || customElements.get('nc-pagination')) return;

  class NcPagination extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.nc-pagination__list');
      this.addEventListener('click', this.onClick.bind(this));
      this.setPage(parseInt(this.getAttribute('data-page'), 10), parseInt(this.getAttribute('data-pages'), 10));
    }

    get page() { return parseInt(this.getAttribute('data-page'), 10) || 1; }
    get pages() { return parseInt(this.getAttribute('data-pages'), 10) || 1; }

    setPage(page, pages) {
      this.setAttribute('data-page', String(page || 1));
      this.setAttribute('data-pages', String(pages || 1));
      this.hidden = this.pages <= 1;
      if (!this.list) return;
      var self = this;
      var current = this.page;
      this.list.textContent = '';
      pageItems(current, this.pages).forEach(function (item) {
        var li = document.createElement('li');
        if (item === '…') {
          li.className = 'nc-pagination__gap';
          li.setAttribute('aria-hidden', 'true');
          li.textContent = '…';
        } else {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'nc-pagination__page';
          b.setAttribute('data-page', String(item));
          b.textContent = String(item);
          var tpl = item === current ? self.getAttribute('data-current-label') : self.getAttribute('data-page-label');
          b.setAttribute('aria-label', (tpl || '{n}').replace('{n}', item));
          if (item === current) b.setAttribute('aria-current', 'page');
          li.appendChild(b);
        }
        self.list.appendChild(li);
      });
    }

    onClick(event) {
      var b = event.target.closest('.nc-pagination__page');
      if (!b || b.getAttribute('aria-current') === 'page' || b.getAttribute('aria-disabled') === 'true') return;
      this.dispatchEvent(new CustomEvent('nc-pagination:change', { bubbles: true, detail: { page: parseInt(b.getAttribute('data-page'), 10) } }));
    }

    // while a page loads the buttons stay in place (same size) but do not react; focus is not lost
    setBusy(on) {
      this.setAttribute('aria-busy', on ? 'true' : 'false');
      Array.prototype.forEach.call(this.querySelectorAll('.nc-pagination__page'), function (b) {
        if (on) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
      });
    }
  }

  customElements.define('nc-pagination', NcPagination);
})();
